module.exports = __webpack_public_path__ + "static/img/4b1a28fe62a99ef6593276e9fef6473b.3802b5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4b1a28fe62a99ef6593276e9fef6473b.jpg
// module id = TP/W
// module chunks = 3